/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  OrganizationDetailsResponse,
  OrganizationSettings,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Organization<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags public-organization-controller
   * @name GetMyOrganization
   * @request GET:/organization
   * @secure
   * @response `200` `OrganizationDetailsResponse` OK
   */
  getMyOrganization = (params: RequestParams = {}) =>
    this.request<OrganizationDetailsResponse, any>({
      path: `/organization`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags public-organization-controller
   * @name UpdateOrganizationSettings
   * @request PATCH:/organization
   * @secure
   * @response `200` `OrganizationDetailsResponse` OK
   */
  updateOrganizationSettings = (
    data: OrganizationSettings,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationDetailsResponse, any>({
      path: `/organization`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
